export default __webpack_public_path__ + "static/media/deleteIcon.bbe247c4.svg";